"use client"

import clsx from 'clsx'

export type CardTone = 'default' | 'muted' | 'dashed' | 'none'
export type CardPadding = 'sm' | 'md' | 'lg' | 'xl'

export type CardOptions = {
  tone?: CardTone
  padding?: CardPadding
  interactive?: boolean
}

const toneMap: Record<CardTone, string> = {
  default: 'border border-[var(--border)] bg-[var(--surface)] shadow-[var(--shadow-card)]',
  muted: 'border border-[color-mix(in_srgb,var(--border) 80%,transparent)] bg-slate-50/80 shadow-[var(--shadow-card)]',
  dashed: 'border border-dashed border-[var(--border)] bg-[var(--surface)]/85 shadow-[var(--shadow-card)]',
  none: '',
}

const paddingMap: Record<CardPadding, string> = {
  sm: 'p-4',
  md: 'p-5',
  lg: 'p-6',
  xl: 'p-8',
}

export function cardClass(options: CardOptions = {}, extra?: string) {
  const { tone = 'default', padding = 'md', interactive = false } = options

  return clsx(
    'card-hover-lift rounded-[var(--radius-card)] transition',
    toneMap[tone],
    paddingMap[padding],
    interactive && 'cursor-pointer',
    extra,
  )
}
